<template>
  <div>
    <v-data-table
      :headers="getReviewHeaders"
      :items="getReviews"
      item-key="_id"
      :options="getReviewOptions"
      v-model="selected"
      show-select
      hide-default-footer
    >
      <template v-slot:[`item.rating`]="{ item }"> {{ Number(item.rating) * 0 + 5 }}</template>
      <template v-slot:[`item.actions`]="{ item }">
        <div class="d-flex">
          <v-icon color="primary" class="mr-2" @click="openEditDialog(item)">
            mdi-square-edit-outline
          </v-icon>
          <v-icon color="error" @click="deleteReview(item._id)">
            mdi-delete
          </v-icon>
        </div>
      </template>
    </v-data-table>
    <div class="d-flex justify-end mt-4">
      <v-pagination
        v-model="getReviewOptions.page"
        :length="getReviewOptions.totalPages || 1"
        @input="pageChange"
      ></v-pagination>
    </div>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card class="pa-4">
        <h2 class="primary--text mb-4">Edit Review</h2>
        <label class="label-form">Customer name</label>
        <v-text-field v-model="editedItem.customerName" placeholder="Customer Name"></v-text-field>
        <label class="label-form">Content</label>
        <v-text-field v-model="editedItem.review" placeholder="Review"></v-text-field>
        <label class="label-form">Rating</label>
        <v-rating color="yellow" length="5" small v-model="editedItem.rating"></v-rating>
        <label class="label-form">Avatar</label>
        <div class="d-flex align-center mb-2">
          <v-avatar size="64" v-if="editedItem.avatar">
            <v-img :src="imageHelpers.url(editedItem.avatar, { width: 100, height: 100 })" />
          </v-avatar>
          <v-btn small class="ml-2" :loading="loadingAvatar" :disabled="loadingAvatar" @click="clickUploadAvatar"
            >Upload Avatar</v-btn
          >
          <input
            ref="avatarUploader"
            type="file"
            accept="image/gif, image/jpeg, image/png , image/jpg"
            style="display:none"
            @change="onChangeAvatar"
          />
          <v-progress-circular v-if="loadingAvatar" indeterminate color="primary" size="32" class="ml-2" />
        </div>
        <Images :images="images" @updateImages="updateImages" />
        <div class="d-flex justify-end mt-6" style="gap: 8px">
          <v-btn text outlined @click="close">
            Cancel
          </v-btn>
          <v-btn depressed color="primary" @click="update(editedItem)">
            Save
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Images from './Images.vue';
import { uploadService } from '@/apis/upload.s';
import imageHelpers from '@/helpers/image';
import axios from 'axios';
export default {
  components: {
    Images,
  },
  props: {
    status: {
      type: String,
      default: 'published',
    },
    search: {
      type: String,
      default: '',
    },
    productId: {
      typeof: String,
      default: '',
    },
    type: {
      typeof: String,
      default: 'store',
    },
  },
  data: function() {
    return {
      dialog: false,
      editedItem: {},
      defaultItem: {},
      actions: [
        {
          title: 'Delete',
          hander: this.deleteReviews,
        },
        {
          title: 'Publish',
          hander: this.publish,
        },
        {
          title: 'Unpublish',
          hander: this.unpublish,
        },
      ],
      selected: [],
      images: [],
      loadingAvatar: false,
      imageHelpers,
    };
  },
  async beforeMount() {
    const queries = this.$route.query;
    await this.$store.dispatch('fetchReviews', {
      status: this.getStatus,
      ...queries,
      type: this.type,
    });
  },
  async created() {},
  computed: {
    ...mapGetters(['getReviews', 'getReviewHeaders', 'getReviewOptions']),
    getStatus() {
      let computeStatus = this.status == 'tab-published' ? 1 : this.status == 'tab-unpublished' ? 0 : null;
      return computeStatus;
    },
  },
  methods: {
    getColor(isPublished) {
      let color = 'default';
      if (isPublished) {
        color = 'green';
      }
      return color;
    },
    clickUploadAvatar() {
      this.$refs.avatarUploader.value = '';
      this.$refs.avatarUploader.click();
    },
    async onChangeAvatar(e) {
      const file = e.target.files[0];
      if (!file) {
        this.$store.commit('setMessages', { messages: 'Không có file nào được chọn.', type: 'error' });
        return;
      }
      const inputTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/jpg'];
      if (!inputTypes.includes(file.type)) {
        this.$store.commit('setMessages', { messages: 'Định dạng ảnh không hỗ trợ.', type: 'error' });
        return;
      }
      this.loadingAvatar = true;
      try {
        const id = this.objectId();
        const type = file.name.split('.').pop();
        const urlData = await uploadService.get({ filename: `avatar-${id}.${type}` });
        if (urlData && urlData.data && urlData.data.presignedUrl) {
          // await uploadService.upload(urlData.data.presignedUrl, file);
          let res = await axios.put(urlData.data.presignedUrl, file, {
            headers: {
              'Content-Type': `${file.type}`,
            },
          });
          this.editedItem.avatar = urlData.data.imagePath;
          this.$store.commit('setMessages', { messages: 'Upload avatar thành công!', type: 'success' });
        } else {
          this.$store.commit('setMessages', { messages: 'Không lấy được link upload.', type: 'error' });
        }
      } catch (error) {
        this.$store.commit('setMessages', { messages: 'Lỗi upload avatar.', type: 'error' });
      }
      this.loadingAvatar = false;
    },
    objectId() {
      return this.hex(Date.now() / 1000) + ' '.repeat(16).replace(/./g, () => this.hex(Math.random() * 16));
    },
    hex(value) {
      return Math.floor(value).toString(16);
    },
    async deleteMany() {
      if (confirm('Do you really want to delete?')) {
        let ids = this.selected.map(item => item._id).join(',');
        if (this.getReviews.length <= ids.length) {
          await this.$store.commit('setReviewOptions', { page: this.getReviewOptions.page - 1 });
          this.updateQuery({ page: this.getReviewOptions.page, search: this.search });
        }
        this.$store.dispatch('deleteReviews', {
          ids: ids,
          page: this.getReviewOptions.page,
          search: this.search,
        });
      }
    },
    async deleteReview(id) {
      if (confirm('Do you really want to delete?')) {
        if (this.getReviews.length <= 1) {
          await this.$store.commit('setReviewOptions', { page: this.getReviewOptions.page - 1 });
          this.updateQuery({ page: this.getReviewOptions.page, search: this.search });
        }

        if (this.type == 'product') {
          await this.$store.dispatch('deleteProductReviews', {
            ids: id,
            productId: this.productId,
            page: this.getReviewOptions.page,
            search: this.search,
            type: this.type,
          });
        } else {
          await this.$store.dispatch('deleteReviews', {
            ids: id,
            page: this.getReviewOptions.page,
            search: this.search,
            type: this.type,
          });
        }
      }
    },
    async update(review) {
      if (review.rating <= 3) {
        if (confirm('Rating is less than 3 point. Do you really want to update?')) {
          await this.$store.dispatch('updateReview', review);
        }
      } else {
        await this.$store.dispatch('updateReview', review);
      }
      await this.$store.dispatch('fetchReviews', {
        status: this.getStatus,
        page: this.getReviewOptions.page,
        search: this.search,
        type: this.type,
        product_id: this.productId,
      });
    },
    openEditDialog(item) {
      this.dialog = true;
      this.editedItem = Object.assign({}, item);
      this.images = item.images;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
    pageChange(page) {
      let query = this.$route.query;
      let queries = {
        status: this.getStatus,
        search: query.search,
        page: page,
        limit: query.limit,
        type: this.type,
        productId: this.productId,
      };
      this.$store.dispatch('fetchReviews', queries);
      this.updateQuery(queries);
    },
    updateQuery(queries) {
      this.$router.push({
        query: queries,
      });
    },
    async updateImages(images) {
      this.editedItem.images = images;
      await this.update(this.editedItem);
    },
  },
  watch: {
    selected: function(val) {
      this.$emit(
        'inputChange',
        this.selected.map(item => item._id),
      );
    },
  },
};
</script>

<style scoped>
.rv-table {
  min-width: 1024px;
}
</style>
